/* eslint-disable react/no-array-index-key */
import icon1 from '../../../assets/images/svg/customers-rosepink.svg';
import icon2 from '../../../assets/images/svg/doctor-tiffanyblue.svg';
import icon3 from '../../../assets/images/svg/doctor-appointment-yellow.svg';
import ContentWithIconBox from '../../../Components/contentWithIconBox/ContentWithIconBox';
import './trustedUsers.css';

function TrustedUsers() {
  return (
    <section className="trustedUsers">
      <ContentWithIconBox
        heading="Trusted by 2 crore+ users every month"
        desc="Meri Sheet is the leading healthcare technology company in Pakistan and today we help 2 crore customers every month."
        iconBoxes={[
          { icon: icon1, countedUser: '2 Crore+', title: 'Monthly Customers' },
          { icon: icon2, countedUser: '100,000+', title: 'Verified Doctors' },
          {
            icon: icon3,
            countedUser: '5 Crore +',
            title: 'Doctor Appointments'
          }
        ]}
      />
    </section>
  );
}

export default TrustedUsers;
